// 配置文件
let path, imPath, imWsPath, VUE_APP_GO_URL;

// 图片域名
// const picDomain = "http://yhdsoss.ds.yhsms.com.cn/";
const picDomain = "https://qlcnbook-console.oss-cn-beijing.aliyuncs.com/";

//  ==============生产环境===============
if (process.env.VUE_APP_MODE === 'production') {
  path = 'https://api.qlcnbook.com';
  // 客服api
  imPath = 'http://im.qlcnbook.com';
  // 客服ws
  imWsPath = 'ws://im.qlcnbook.com';
}

// ==============测试环境===============
if (process.env.VUE_APP_MODE === 'test') {
  path = 'https://api.test.qlcnbook.com'; //测试库
  // 客服api
  imPath = 'https://im.test.qlcnbook.com'; //测试库
  // 客服ws
  imWsPath = 'ws://im.test.qlcnbook.com'; //测试库
}

// ==============开发环境===============
if (process.env.VUE_APP_MODE === 'development') {
  path = 'https://api.dev.qlcnbook.com'; //测试库
  // 客服api
  imPath = 'https://im.dev.qlcnbook.com'; //测试库
  // 客服ws
  imWsPath = 'ws://im.sandbox.qlcnbook.com'; //测试库
}

module.exports = {
  path,
  imPath,
  imWsPath,
  picDomain
};